import { render, staticRenderFns } from "./WistiaVideo.vue?vue&type=template&id=0df2f448"
import script from "./WistiaVideo.vue?vue&type=script&lang=js"
export * from "./WistiaVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports